/**
 * returns file extension.
 * ex.
 * image/svg+xml = svg
 * image/jpg = jpg
 */
export function getFileExtension(file: File): string {
  return /(?:\/)(\w+)/.exec(file.type)?.[1] ?? '';
}

export enum FileType {
  Png = 'image/png',
  Jpg = 'image/jpeg',
  Svg = 'image/svg+xml',
}
